import { DefaultRoute } from "../router/routes";
import {API_URL} from "@configs"; // ** Checks if an object is empty (returns boolean)

// ** Checks if an object is empty (returns boolean)
export const isObjEmpty = (obj) => Object.keys(obj).length === 0;

// ** Returns K format from a number
export const kFormatter = (num) =>
  num > 999 ? `${(num / 1000).toFixed(1)}k` : num;

// ** Converts HTML to string
export const htmlToString = (html) => html.replace(/<\/?[^>]+(>|$)/g, "");

// ** Checks if the passed date is today
const isToday = (date) => {
  const today = new Date();
  return (
    /* eslint-disable operator-linebreak */
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
    /* eslint-enable */
  );
};

/**
 ** Format and return date in Humanize format
 ** Intl docs: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/format
 ** Intl Constructor: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat
 * @param {String} value date to format
 * @param {Object} formatting Intl object to format with
 */
export const formatDate = (
  value,
  formatting = { month: "short", day: "numeric", year: "numeric" }
) => {
  if (!value) return value;
  return new Intl.DateTimeFormat("en-US", formatting).format(new Date(value));
};

// ** Returns short month of passed date
export const formatDateToMonthShort = (value, toTimeForCurrentDay = true) => {
  const date = new Date(value);
  let formatting = { month: "short", day: "numeric" };

  if (toTimeForCurrentDay && isToday(date)) {
    formatting = { hour: "numeric", minute: "numeric" };
  }

  return new Intl.DateTimeFormat("en-US", formatting).format(new Date(value));
};

/**
 ** Return if user is logged in
 ** This is completely up to you and how you want to store the token in your frontend application
 *  ? e.g. If you are using cookies to store the application please update this function
 */
export const isUserLoggedIn = () => localStorage.getItem("userData");
export const getUserData = () => localStorage.getItem("userData");

/**
 ** This function is used for demo purpose routes navigation
 ** In real app you won't need this function because your app will navigate to same routes for each users regardless of ability
 ** Please note role field is just for showing purpose it's not used by anything in frontend
 ** We are checking role just for ease
 * ? NOTE: If you have different pages to navigate based on user ability then this function can be useful. However, you need to update it.
 * @param {String} userRole Role of user
 */
export const getHomeRouteForLoggedInUser = (userRole) => {
  return "/home";

  console.log(userRole);
  if (userRole) return DefaultRoute;
  return "/signin";
};

// ** React Select Theme Colors
export const selectThemeColors = (theme) => ({
  ...theme,
  colors: {
    ...theme.colors,
    primary25: "#7367f01a", // for option hover bg-color
    primary: "#7367f0", // for selected option bg-color
    neutral10: "#7367f0", // for tags bg-color
    neutral20: "#ededed", // for input border-color
    neutral30: "#ededed", // for input hover border-color
  },
});

export const p2e = (s) => s.replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));

export const a2e = (s) => s.replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d));

function getLastMove(moveString) {
  return moveString.split(/\d+\./).filter(Boolean).pop().trim();
}

export const pgnRoundConverter = (moves) => {
  if (moves.length === 0) return;
  let filteredMoves = [moves[moves.length - 1]]; // Start with the last move

  for (let i = moves.length - 2; i >= 0; i--) {
    if (!moves[i + 1].startsWith(moves[i])) {
      filteredMoves.push(moves[i]);
    }
  }

  filteredMoves.reverse();

  // This is the main change. Splitting the string into individual moves.
  const finalString = filteredMoves[0];
  const splitMoves = finalString.split(/(?=\d+\.)/); // This regular expression splits the string at the move numbers.
  return splitMoves.map((move) => move.trim()); // Remove any extra spaces
};

export function convertToPairs(array) {
  return array.reduce((acc, curr, index, arr) => {
    if (index % 2 === 0) {
      acc.push(arr.slice(index, index + 2));
    }
    return acc;
  }, []);
}

export function convertSearchParamsToQuery(searchParams) {
  const params = new URLSearchParams();

  for (let key in searchParams) {
    if (searchParams[key]) params.append(key, searchParams[key]);
  }
  return params.toString();
}

export function formatImageSrc(src) {
  if (!src) return null;
  if (
    src.startsWith("http") ||
    src.endsWith("/avatar-s-11.jpg") ||
    src.endsWith("/avatar-s-11.60b6ef08.jpg")
  ) {
    return src;
  } else {
    return `${API_URL}${src}`.replace(/(\.com)\/\//, "$1/");
  }
}

export function calculateAge(birthday) {
  const today = new Date();
  const birthDate = new Date(birthday);
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();

  if (
    monthDiff < 0 ||
    (monthDiff === 0 && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return age;
}

export const calculateAgeCutOfDate = (birthday, cutOffDate) => {
  const birthDate = new Date(birthday);
  let currentDate = new Date();

  if (cutOffDate) {
    currentDate = new Date(cutOffDate);
  }

  let age = currentDate.getFullYear() - birthDate.getFullYear();
  const monthDiff = currentDate.getMonth() - birthDate.getMonth();
  const dayDiff = currentDate.getDate() - birthDate.getDate();

  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age--;
  }

  return age;
};

export function formatPhoneNumber(phoneNumber) {
  // Ensure the input is treated as a string
  const str = phoneNumber.toString();

  // Split the number into parts
  const part1 = str.slice(0, 4); // First 4 digits
  const part2 = str.slice(4, 7); // Next 3 digits
  const part3 = str.slice(7); // Remaining digits

  // Combine the parts with spaces, skipping empty parts
  return [part1, part2, part3].filter(Boolean).join(" ");
}

export function formatTime(milliseconds) {
  const totalSeconds = Math.floor(milliseconds / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;

  if (minutes > 0) {
    return `${minutes}:${seconds.toString().padStart(2, '0')} min`;
  }
  return `${seconds} sec`;
}

export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

